import { render, staticRenderFns } from "./ItemAdd.vue?vue&type=template&id=b662a584"
import script from "./ItemAdd.vue?vue&type=script&lang=js"
export * from "./ItemAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports